import * as HttpService from "../../../../service/HttpService";

/******* 
* @description: 处理GET请求参数拼接
* @param  obj  
* @return {Promise<Response>}
*/
const params = (obj) => {
    let result = '';
    let item;
    for (item in obj) {
        if (obj[item] && String(obj[item])) {
            result += `&${item}=${obj[item]}`;
        }
    }
    if (result) {
        result = '?' + result.slice(1);
    }
    return result;
}
/* 
发布设置
*/
export const reportSetting = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/reportSetting", params);
};

/* 
查询报告
*/
export const getReportInfo = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/getReportSmartEnergyServiceInfo", params);
};
/* 
查询报告
*/
export const getReportSettingStatus = (params) => {
    return HttpService.get(HttpService.DOMAIN + "/report-smart-energy/getReportSettingStatus");
};

/**
 * 查询用户列表
 */
 export const queryUserList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/eneryUser/getUserInfo", params);
};

/**
 * 查询用户列表
 */
 export const saveOrUpdateReport = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/saveOrUpdateReportSmartEnergyService", params);
};

/**
 * 查询用户列表
 */
 export const getorgList = (no) => {
        return HttpService.get(HttpService.DOMAIN + "/treeView/orgCustSel?parentOrgNo="+no);
    };

/**
 * 生成报告--企业告警信息
 */
 export const reportAlarmInfoApi = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/reportAlarmInfo", params);
};
/**
 * 生成报告--告警名称占比
 */
 export const getReportAlarmNamePro = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/getReportAlarmNamePro", params);
};
/**
 * 生成报告--告警类型占比
 */
 export const getReportAlarmTypePro = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/getReportAlarmTypePro", params);
};
/**
 * 生成报告--三相不平衡电流曲线
 */
 export const getCeStatCecustIabcDayCure = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/getCeStatCecustIabcDayCure", params);
};
/**
 * 生成报告--变压器设备三相不平衡电流曲线
 */
 export const getCeStatCeDeviceIabcDayCurve = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/getCeStatCeDeviceIabcDayCurve", params);
};
/**
 * 生成报告--电压越限曲线
 */
 export const getCeStatCecustUabcDayCure = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/getCeStatCecustUabcDayCure", params);
};
/**
 * 生成报告--电压越限 新
 */
 export const getCeStatCeDeviceUabcDayCurve = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/getCeStatCeDeviceUabcDayCurve", params);
};
/**
 * 生成报告--功率因素曲线
 */
 export const getceStatCecustAvgFactorDayCure = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/getceStatCecustAvgFactorDayCure", params);
};
/**
 * 生成报告--功率因素曲线
 */
 export const getCeStatCecustLineLossDayCure = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/getCeStatCecustLineLossDayCure", params);
};
/**
 * 生成报告--线损电量分析曲线
 */
 export const getCeStatCecustLoadDayCure = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/getCeStatCecustLoadDayCure", params);
};
/**
 * 生成报告--本月用电小结-企业电量曲线
 */
 export const electricityConsumptionApi = (custId,reportDate) => {
    return HttpService.get(HttpService.DOMAIN + "/electricitySummaryController/electricityConsumption?custId="+custId+"&reportDate="+reportDate);
};
/**
 * 生成报告--尖峰谷用电量占比分时段电量
 */
 export const getTmplInputElecPower = (custId,reportDate) => {
    return HttpService.get(HttpService.DOMAIN + "/electricitySummaryController/getTmplInputElecPower?custId="+custId+"&reportDate="+reportDate);
};
/**
 * 生成报告--变压器平均负荷曲线
 */
 export const getCeStatCeDeviceAvgValueDayCurve = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/getCeStatCeDeviceAvgValueDayCurve",params);
};
/**
 * 生成报告--获取设备的电量  各关口月电量排名top3
 */
 export const equipmentLoad = (data) => {
    return HttpService.get(HttpService.DOMAIN + "/electricitySummaryController/equipmentLoad"+params(data));
};
/**
 * 生成报告--获取设备的负荷 各关口月平均负荷排名top3
 */
 export const loadAverageTopThree = (data) => {
    return HttpService.get(HttpService.DOMAIN + "/electricitySummaryController/loadAverageTopThree"+params(data));
};
/**
 * 生成报告--电费，相较于上月%，电价
 */
 export const electricitybill = (data) => {
    return HttpService.get(HttpService.DOMAIN + "/electricitySummaryController/electricitybill"+params(data));
};

/**
 * 变压器容量核定接口（回归预测接口）
 * creator  刘亮林
 * http://yapi.ebike-charge.com:6060/project/318/interface/api/16101
 */
export const getForecastData = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/report-smart-energy/getForecastData", params);
};